import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

/**
 * Calio Lucide Icon Component
 *
 * A wrapper around Lucide icons with Tailwind-first styling support.
 * Icons are registered globally in app.config.ts via LUCIDE_ICONS.
 *
 * @example
 * Basic usage with Tailwind classes:
 * ```html
 * <calio-lucide-icon name="calendar" class="tw-w-5 tw-h-5 tw-text-primary" />
 * ```
 *
 * @example
 * With size and color props (legacy style):
 * ```html
 * <calio-lucide-icon name="bell" [size]="20" color="var(--primary)" />
 * ```
 *
 * @example
 * With click handler:
 * ```html
 * <calio-lucide-icon name="settings" class="tw-w-4 tw-h-4" (clicked)="onSettingsClick()" />
 * ```
 */
@Component({
  selector: 'calio-lucide-icon',
  templateUrl: './calio-lucide-icon.component.html',
  styleUrl: './calio-lucide-icon.component.scss',
  imports: [LucideAngularModule, NgClass],
})
export class CalioLucideIconComponent {
  /** Icon name (kebab-case, e.g., 'calendar', 'chevron-right', 'settings-2') */
  name = input.required<string>();

  /** Icon size in pixels (default: 24). Use Tailwind classes like tw-w-5 for responsive sizing */
  size = input<number>(24);

  /** Stroke width (default: 2) */
  strokeWidth = input<number>(2);

  /** Icon color (default: currentColor). Use Tailwind classes like tw-text-primary instead */
  color = input<string>('currentColor');

  /** Additional CSS classes (Tailwind classes recommended) */
  customClass = input<string>('');

  /** Click event emitter */
  clicked = output<void>();
}
